import { render } from "./MergedXrayReport.vue?vue&type=template&id=4e7640dc&scoped=true"
import script from "./MergedXrayReport.vue?vue&type=script&lang=js"
export * from "./MergedXrayReport.vue?vue&type=script&lang=js"

import "./MergedXrayReport.vue?vue&type=style&index=0&id=4e7640dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e7640dc"

export default script